<template>
  <div class="container">
    <auth-connector
      v-if="connectChannel"
      :channelType="getConnectorsType" />

    <div>
      <div class="create-option text-center row">
        <div class="col">
          <div class="centered">
            <h6>
              {{ $t(' Sqwiz.facebook.title') }}
            </h6>
            <input-button
              v-if="showConnectButton"
              variant="standardInput"
              btnStyle="ok-style"
              smaller
              boxy
              centered
              class="mt-2 mb-2"
              :inputPlaceholder="$t('Button.connect')"
              @click="setConnector" />

            <router-link
              v-else
              :to="{ name: 'userConnections' }">

              <input-button
                variant="standardInput"
                btnStyle="ok-style"
                smaller
                boxy
                centered
                class="mt-2 mb-2"
                :inputPlaceholder="$t('Button.edit')" />

            </router-link>

            <ul
              class="facebook-items"
              v-for="fbC in getAvailableFbChannels"
              :key="fbC.identity">

              <li>
                <div class="flexed">
                  <span class="mr-2">
                    {{fbC.label}}
                    <a
                      :href="fbC.meta.profileUrl"
                      target="_blank">

                      <icon name="link" />
                    </a>
                  </span>

                  <input-button
                    :inputPlaceholder="$t('Button.use')"
                    class="smaller-padds"
                    variant="standardInput"
                    btnStyle="ok-btn"
                    spinner
                    :dataLoading="isSpinnerShown(fbC.identity)"
                    @click="createSiteWithFb(fbC.identity)" />

                </div>
              </li>
            </ul>

            <p class="mt-5">
              {{ $t(' Sqwiz.createSiteNoFB') }}
            </p>
          </div>
        </div>
      </div>
        
      <div class="row justify-content-center">
        <h1
          class="or-text col-5"
          data-v-step="websites.create">

          {{ $t('Labels.orText') }}
        </h1>
      </div>
        
      <div class="create-option row">
        <div class="col">
          <div class="centered">
            <h6>
              {{ $t('Sqwiz.form.title') }}
            </h6>
            
            <input-container
              ref="mainInputContainer"
              class="post-creator container"
              @updateValidity="updateValidity">

              <input-select
                :inputPlaceholder="$t('Sqwiz.culture.placeholder')"
                class="select-input"
                variant="standardInput"
                :defaultValue="companySiteData.culture"
                stretched
                required
                inputName="culture"
                :selectOptions="sitesCulture"
                :constraints="getCultureConstraints"
                @fieldUpdate="fieldUpdate" />

              <input-select
                :inputPlaceholder="$t('Sqwiz.portal.placeholder')"
                class="select-input"
                variant="standardInput"
                :defaultValue="companySiteData.portal"
                stretched
                overlap
                required
                inputName="portal"
                :selectOptions="sitesPortal"
                :constraints="getPortalConstraints"
                @fieldUpdate="fieldUpdate" /> 

              <input-select
                :inputPlaceholder="$t('Sqwiz.category')"
                class="select-input"
                variant="standardInput"
                stretched
                overlap
                required
                inputName="category"
                :selectOptions="companyCategories"
                :constraints="getCategoryConstraints"
                @fieldUpdate="fieldUpdate" />
              
              <input-text
                inputName="title"
                variant="standardInput"
                stretched
                overlap
                required
                :inputPlaceholder="$t('Sqwiz.title')"
                :constraints="getTitleConstraints"
                @fieldUpdate="fieldUpdate" />

              <input-text
                inputName="address"
                variant="standardInput"
                stretched
                overlap
                :inputPlaceholder="$t('Sqwiz.address')"
                :constraints="getAddressConstraints"
                @fieldUpdate="fieldUpdate" />

              <input-text
                inputName="phone"
                variant="standardInput"
                stretched
                overlap
                :inputPlaceholder="$t('Sqwiz.phone')"
                :constraints="getPhoneConstraints"
                @fieldUpdate="fieldUpdate" />

              <input-text
                inputName="city"
                variant="standardInput"
                stretched
                overlap
                :inputPlaceholder="$t('Sqwiz.city')"
                :constraints="getCityConstraints"
                @fieldUpdate="fieldUpdate" />

              <input-text
                inputName="postalcode"
                variant="standardInput"
                stretched
                overlap
                :inputPlaceholder="$t('Sqwiz.postalCode')"
                :constraints="getPostalCodeConstraints"
                @fieldUpdate="fieldUpdate" />

              <div class="text-center">
                <input-button
                  variant="standardInput"
                  btnStyle="ok-style"
                  spinner
                  :dataLoading="isSpinnerShown('forum')"
                  :dissabled="!requiredFieldsEntered"
                  :inputPlaceholder="$t('Button.createSite')"
                  @click="createSite" />

              </div>
            </input-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from '@/components/standard/input/InputText'
import InputNumber from '@/components/standard/input/InputNumber'
import InputButton from '@/components/standard/input/InputButton'
import InputSelect from '@/components/standard/input/InputSelect'
import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import objectHelpers from '@/assets/modules/objectHelpers'
import apiConnector from '@/mixins/apiConnector.js'
import AuthConnector from '@/components/standard/connectors/AuthConnector'

import avalableItems from '@/assets/configurations/avalableItems.json'
import channels from '@/mixins/pagination/providers/channels'
import nManager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'

import connectionHelper from '@/assets/modules/channels/connectionHelper'

import cb from '@/assets/modules/constraints/constraintBuilder'

import InputContainer from '@/components/standard/input/InputContainer'

import connectors from '@/mixins/standard/connectors/connectors'

export default {
  data () {
    return {
      connectChannel: false,

      companySiteData: { culture: 'sl-SI', portal: 7 },
      requiredFields: ['culture', 'portal', 'category', 'title'],

      fbUsed: false,
      siteCreating: false,

      hasValidInputs: false,

      companyCategories: avalableItems.CreateSite.categories,
      sitesCulture: avalableItems.CreateSite.cultures,
      sitesPortal: avalableItems.CreateSite.portal
    }
  },

  methods: {
    updateValidity (e) {
      this.hasValidInputs = e.valid
    },

    setConnector () {
      this.connectChannel = 'facebookProfile'
    },

    // Method is either 'form' - if data entered thorugh a form or credential's
    // id if created via a channel
    isSpinnerShown (method) {
      return this.siteCreating === method
    },

    // Skip mutation is used by tests
    createSiteWithFb (identity, skipMutation = false) {
      if (this.siteCreating) return false

      this.$set(this.companySiteData, 'facebook', identity)
      this.fbUsed = true
      this.siteCreating = identity


      if (!skipMutation) {
        nManager.okNotification(this, 'Notification.ok.websiteCreating.label')
        this.attemptSiteCreation()
      }
    },

    fieldUpdate (e) {
      if (!e.value) {
        this.$delete(this.companySiteData, e.input)
      } else {
        this.$set(this.companySiteData, e.input, e.value)
      }
    },

    createSite (e, skipMutation = false) {
      if (this.siteCreating) return false

      this.fbUsed = false
      this.siteCreating = 'forum'

      if (!skipMutation) {
        this.attemptSiteCreation()
      }
    },

    attemptSiteCreation () {
      if (!this.requiredFieldsEntered && !this.fbUsed) {
        nManager.nokNotification(this, 'Izpolnite obvezna polja')
        return
      }

      let okCallback = (e) => {
        this.siteCreating = false
        nManager.okNotification(this, 'Notification.ok.websiteCreated.label')

        try {
          // Redirect to edit new page
          window.location.href = e.meta.editUrl + '&welcome=1'
          this.$router.push({ name: 'sitesOverview' })
        } catch (e) {
          // In case of an error, go to site viewer
          this.$router.push({ name: 'sitesOverview' })
        }
      }

      let failCallback = (e) => {
        this.siteCreating = false
        let message = 'Nekaj je narobe'
        message = resolver.resolve(e.message, message)

        nManager.nokNotification(this, message)
      }

      // GQL Mutation...
      let siteData = objectHelpers.cloneObject(this.companySiteData)
      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(siteData, 'createSqwizPage', 'mutation', [], {
          'category': 'Int',
          'facebook': 'UUID',
          'culture': 'String',
          'portal': 'Int'
        })

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    }
  },
  computed: {
    /**
     * Tells if channel is false unconnected
     * @returns {Boolean}
     */
    isFalseUnconnected () {
      return connectionHelper.isFalseUnconnected('facebookPage', this.getInvisibleChannels)
    },

    getCultureConstraints () {
      return cb.build('text', { onInit: true, required: true, errorMsg: 'Neveljavna izbira' })
    },

    getPortalConstraints () {
      return cb.build('text', { onInit: true, required: true, errorMsg: 'Neveljavna izbira' })
    },

    getCategoryConstraints () {
      return cb.build('text', { onInit: true, required: true, errorMsg: 'Neveljavna izbira', allowed: 0 })
    },

    getTitleConstraints () {
      return cb.build('text', { onInit: true, required: true })
    },

    getAddressConstraints () {
      return cb.build('text', { onInit: true, optional: true })
    },

    getPhoneConstraints () {
      return cb.build('phoneNumber', { onInit: true, optional: true })
    },

    getCityConstraints () {
      return cb.build('text', { onInit: true, optional: true })
    },

    getPostalCodeConstraints () {
      return cb.build('number', { onInit: true, optional: true })
    },

    requiredFieldsEntered () {
      return this.hasValidInputs
    },

    getAvailableFbChannels () {
      let obj = (this.getGroupedChannels || {}).facebookPage || {}
      return Object.values(obj)
    },

    /**
     * Tells if tour is running
     * @returns {Boolean}
     */
    isTourRunning () {
      return !!(this.$tours.mainPageTour || {}).isRunning
    },

    activeConnectorType () {
      return this.connectChannel
    },

    /**
     * Tells connect button's state
     * @returns {Boolean} true means that it connects fb, false means that it manages fb pages
     */
    showConnectButton () {
      return !this.isFalseUnconnected || this.isTourRunning
    }
  },
  components: {
    'auth-connector': AuthConnector,
    'input-text': InputText,
    'input-number': InputNumber,
    'input-button': InputButton,
    'input-select': InputSelect,
    'input-container': InputContainer
  },
  mixins: [
    channels,
    apiConnector,
    connectors
  ]
}
</script>

<style scoped>
.facebook-items li {
  list-style-type: none;
  margin-top: 10px;
  margin-bottom: 5px;
}
.facebook-items {
  padding: 0;
  max-width: 500px;
  margin: 20px auto;
}
.smaller-padds {
  padding-top: 7px;
  padding-bottom: 7px;
  padding: 7px 20px;
}
.flexed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.post-creator{
  max-width: 500px;
}
.create-option {
  padding: 10px 5px;
  margin: 10px;
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 0 1px #1E1E1E;
}
.or-text {
  color: #78C05A;
  text-transform: uppercase;
  font-size: 40px;
  margin: 20px;
  text-align: center;
}
.centered {
  margin: 0 auto;
}
h6{
  font-weight: 900;
  margin: 20px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/service/siteManager/CreateSite.vue?6bc87a7c